import { render } from "./V1OtherAmountView.vue?vue&type=template&id=c708bbe6&scoped=true&ts=true"
import script from "./V1OtherAmountView.vue?vue&type=script&lang=ts"
export * from "./V1OtherAmountView.vue?vue&type=script&lang=ts"

import "./V1OtherAmountView.vue?vue&type=style&index=0&id=c708bbe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c708bbe6"]])

export default __exports__